import { Alert, Box, Typography } from '@mui/material';
import React, { useState } from 'react';
import { IStoryViewMessages } from '../../../../types';
import { MAX_NUMBER_OF_MERGE_TAGS, useMergeTagsContext } from '../../../common/context/MergeTagsContext';

import { styles } from './MaxNumberOfMergeTagsBanner.styles';

export type MaxNumberOfMergeTagsBannerProps = {
  messages: IStoryViewMessages;
};

export const MaxNumberOfMergeTagsBanner = ({ messages }: MaxNumberOfMergeTagsBannerProps) => {
  const { storyMergeTagList } = useMergeTagsContext();
  const [showBanner, setShowBanner] = useState(true);

  if (storyMergeTagList.length < MAX_NUMBER_OF_MERGE_TAGS || !showBanner) {
    return null;
  }

  return (
    <Box sx={styles.container}>
      <Alert
        severity="warning"
        data-test="max-number-of-merge-tags-banner"
        onClose={() => setShowBanner(false)}
      >
        <Typography component="div" sx={styles.header} data-test="max-number-of-merge-tags-banner-header">
          {messages.maxNumberOfMergeTags}
        </Typography>
        <Box data-test="max-number-of-merge-tags-banner-body">
          {messages.maxNumberOfMergeTagsDesc({ maxNumber: MAX_NUMBER_OF_MERGE_TAGS })}
        </Box>
      </Alert>
    </Box>
  );
};
